import { render, staticRenderFns } from "./UpdateTicketCronConfig.vue?vue&type=template&id=4be59476&"
import script from "./UpdateTicketCronConfig.vue?vue&type=script&lang=ts&"
export * from "./UpdateTicketCronConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports